import React, { useContext, useMemo } from 'react';
import { Button, MxColumnsType } from '@maxtropy/components';
import { PlusOutlined } from '@ant-design/icons';
import { ActionType, IEC104Point, DataPointType, DataProperty } from '../../../../../types';
import { PointContext, PointContextProps } from '../../../contextTypes';
import IEC104PointBase from './IEC104PointBase';
import CreateForm from './CreateForm';
import Header from '../../Header';

export type EdgeDeviceTemplatePoint = IEC104Point & { actionType?: ActionType };

interface IEC104PointProps {
  loading?: boolean;
  editColumns?: MxColumnsType<EdgeDeviceTemplatePoint>;
  onUpdate?: (values: any) => any;
  dataPropertiesAll?: DataProperty[];
  usedProperties?: number[];
  usedIdentifier?: string[];
}

const IEC104PointCom: React.FC<IEC104PointProps> = props => {
  const { loading, editColumns, onUpdate, dataPropertiesAll, usedProperties, usedIdentifier } = props;

  const { row, setRow, info, promptSlot, editable } = useContext(
    PointContext
  ) as PointContextProps<EdgeDeviceTemplatePoint>;

  const _row = useMemo(() => {
    if (row) {
      const { parameters, ...rest } = row;
      return {
        ...rest,
        ...parameters,
      };
    } else {
      return row;
    }
  }, [row]);

  const onOk = (values: any) => {
    const {
      dataPropertyId,
      dataPropertyName,
      physicalUnitId,
      physicalUnitGeneralName,
      identifier,
      hasProperty,
      writable,
      remark,
      ...rest
    } = values;
    const submitValues = {
      pointType: DataPointType.BASE_POINT,
      dataPropertyId,
      dataPropertyName,
      physicalUnitId,
      physicalUnitGeneralName,
      identifier,
      hasProperty,
      writable,
      remark,
      parameters: {
        driveType: info?.driveType,
        pointType: DataPointType.BASE_POINT,
        ...rest,
      },
    };
    if (onUpdate) {
      onUpdate(submitValues);
    }
  };

  return (
    <>
      <Header slot={promptSlot}>
        {editable && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() =>
              setRow?.({
                pointType: DataPointType.BASE_POINT,
              })
            }
          >
            添加采集点
          </Button>
        )}
      </Header>
      <IEC104PointBase editColumns={editColumns} loading={loading} dataPropertiesAll={dataPropertiesAll} />
      {row && (
        <CreateForm
          onCancel={() => setRow?.(undefined)}
          row={_row}
          dataPropertiesAll={dataPropertiesAll}
          usedProperties={usedProperties}
          usedIdentifier={usedIdentifier}
          onOk={onOk}
        />
      )}
    </>
  );
};

export default IEC104PointCom;
